import { CASE_REPO } from '@/api/apiModules'
import FormUtil from '@/utils/formUtil'
export default {
  viewType: 'form',
  module: CASE_REPO,
  params: null,
  extraParams: null,
  okAction: 'copy',
  formatData(data) {
    if (this.extraParams && this.extraParams.sourceTestCaseId) {
      data.sourceTestCaseId = this.extraParams?.sourceTestCaseId
    }
    return data
  },
  cb() {
    const { originalFormValue } = this
    const { testCaseName } = originalFormValue
    FormUtil.updateValue(this, 'testCaseName', testCaseName + ' copy')
    const model = this.formRef.model
    this.views?.extraParams?.recommendedId &&
      (model.compatibleDTOList = [{ productId: this.views?.extraParams?.recommendedId, osTypeId: null }])
  },
  view: {
    title: '复制用例',
    labelPosition: 'right',
    labelWidth: '170px',
    width: '700px',
    content: [
      {
        $id: 'testCaseName',
        $type: 'input',
        label: 'testcaseMng.testCaseName',
        $el: {
          placeholder: '请输入用例名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseName'
          }
        ]
      },
      {
        $id: 'testCaseType',
        $type: 'radio-group',
        label: 'testcaseMng.testCaseType',
        $el: { disabled: true },
        $options: [
          {
            label: '功能用例',
            value: 'BUSINESS'
          },
          {
            label: '外设用例',
            value: 'PERIPHERAL'
          },
          {
            label: '软件用例',
            value: 'SOFTWARE'
          }
        ],
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseType'
          }
        ]
      },
      {
        $id: 'testCaseContent',
        $type: 'input',
        $el: {
          placeholder: '请输入用例内容',
          type: 'textarea',
          rows: 5
        },
        label: 'testcaseMng.testCaseContent',
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseContent'
          }
        ]
      },
      {
        $id: 'testCaseScene',
        $type: 'input',
        label: 'testcaseMng.testCaseScene',
        $el: {
          placeholder: '请输入用例场景',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseScene'
          }
        ]
      },
      {
        $id: 'userDemand',
        $type: 'input',
        label: 'testcaseMng.testUserDemand',
        $el: {
          placeholder: '请输入用户诉求',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testUserDemand'
          }
        ]
      },
      {
        $id: 'testCaseStep',
        $type: 'input',
        label: 'testcaseMng.testCaseStep',
        $el: {
          placeholder: '请输入用户步骤',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseStep'
          }
        ]
      },
      {
        $id: 'testCaseExpectedResult',
        $type: 'input',
        label: 'testcaseMng.testCaseExpectedResult',
        $el: {
          placeholder: '请输入预期结果',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: 'testcaseMng.testCaseExpectedResult'
          }
        ]
      },
      {
        $id: 'remarks',
        $type: 'input',
        label: 'testcaseMng.remarks',
        tip: {
          description: ['testcaseMng.tips.remarks']
        },
        $el: {
          placeholder: '请输入备注',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'compatibleDTOList',
        $type: 'sky-product-os-relate',
        label: '支持的产品及操作系统',
        $default: null,
        rules: [
          {
            // notEmpty: '支持的产品及操作系统'
          }
        ]
      }
    ]
  }
}
